import React from "react";

const CodeExpressionIcon = ({ size = 24, stroke = "#69687A", style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" style={style}>
    <path d="M17 17L22 12L17 7M7 7L2 12L7 17M14 3L10 21" stroke={stroke} strokeOpacity="1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CodeExpressionIcon;
